"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOUSE_TYPES_NL = exports.HOUSE_APARTMENT_TYPE_NL = exports.HOUSE_GENERAL_TYPE_NL = exports.HOUSE_TYPE_CATEGORIES_NL = exports.APARTMENT_HOUSE_TYPES_WITH_FLOOR = exports.APARTMENT_HOUSE_TYPES_WITH_ROOF = exports.MIDDLE_APARTMENT_HOUSE_TYPES = exports.HOUSE_TYPE_IDS = void 0;
exports.HOUSE_TYPE_IDS = {
    type1: 'detached',
    type2: 'duplex',
    type3: 'corner',
    type4: 'row',
    type5: 'apartment',
    // Maisonnettes (appartementen met meerdere woonlagen)
    type6: 'maisonnette',
    type7: 'maisonnette',
    type8: 'maisonnette',
    type9: 'maisonnette',
    type10: 'maisonnette',
    type11: 'maisonnette',
    type12: 'maisonnette',
    type13: 'maisonnette',
    // Appartementen met 1 woonlaag
    type14: 'apartment',
    type15: 'apartment',
    type16: 'apartment',
    type17: 'apartment',
    type18: 'apartment',
    type19: 'apartment',
    type20: 'apartment',
    type21: 'apartment',
    type22: 'linked', // Schakelwoning
};
exports.MIDDLE_APARTMENT_HOUSE_TYPES = [
    9,
    13,
    17,
    21, // apartment tussen midden
];
exports.APARTMENT_HOUSE_TYPES_WITH_ROOF = [
    6,
    7,
    10,
    11,
    14,
    15,
    18,
    19, // apartment dak
];
exports.APARTMENT_HOUSE_TYPES_WITH_FLOOR = [
    6,
    8,
    10,
    12,
    14,
    16,
    18,
    20, // apartment vloer
];
exports.HOUSE_TYPE_CATEGORIES_NL = {
    apartment: 'Appartement',
    corner: 'Hoekwoning',
    detached: 'Vrijstaande woning',
    duplex: 'Twee-onder-één-kapwoning',
    linked: 'Schakelwoning',
    maisonnette: 'Maisonnette',
    row: 'Tussenwoning',
};
exports.HOUSE_GENERAL_TYPE_NL = {
    // Sorted by average consumption
    1: 'Vrijstaande woning',
    2: 'Twee-onder-één-kapwoning',
    3: 'Hoekwoning',
    4: 'Tussenwoning',
    5: 'Appartement',
    22: 'Schakelwoning', // Schakelwoning
};
exports.HOUSE_APARTMENT_TYPE_NL = {
    6: 'Maisonette op de hoek en BG met dak',
    7: 'Maisonette op de hoek met dak',
    8: 'Maisonette op de hoek en BG',
    9: 'Maisonette op de hoek',
    10: 'Maisonette op de BG met dak',
    11: 'Maisonette met dak',
    12: 'Maisonette op de BG',
    13: 'Maisonette tussenappartement',
    // Appartementen met 1 woonlaag
    14: 'Appartement op de hoek en BG met dak',
    15: 'Appartement op de hoek met dak',
    16: 'Appartement op de hoek en BG',
    17: 'Appartement op de hoek',
    18: 'Appartement op de BG met dak',
    19: 'Appartement met dak',
    20: 'Appartement op de BG',
    21: 'Tussenappartement', // tussenappartement
};
exports.HOUSE_TYPES_NL = { ...exports.HOUSE_GENERAL_TYPE_NL, ...exports.HOUSE_APARTMENT_TYPE_NL };
